import React, { memo, useContext, useEffect, useState } from "react";
import { CartOverlaysContext, isJioHotstarFlow } from "@swiggy-private/checkout-core";
import { GenericCrouton } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";
import { GenericCroutonProps } from "@swiggy-private/cart-types";
import { UpdateCartContext } from "@cart-client/contexts/UpdateCartContext";
import { CookingInstructionsFocusContext } from "@cart-client/contexts/CookingInstructionsFocusContext";

const GenericCroutonWrapper = () => {
    const contextValue = useContext(CartOverlaysContext);
    const { shouldRenderCrouton, onCloseCrouton, subscribeToCroutonContent, getCroutonContentSnapshot } = contextValue;
    const { updateCartInProgress } = useContext(UpdateCartContext);
    const { isCookingInstructionsFocused } = useContext(CookingInstructionsFocusContext);

    const [croutonContent, setCroutonContent] = useState<GenericCroutonProps | null>(getCroutonContentSnapshot());

    useEffect(() => {
        setCroutonContent(getCroutonContentSnapshot());
        return subscribeToCroutonContent(() => setCroutonContent(getCroutonContentSnapshot()));
    }, [subscribeToCroutonContent, getCroutonContentSnapshot]);

    // Don't render crouton when cart update is in progress (shimmer is showing)
    // This prevents the crouton from appearing under the shimmer overlay
    if (!shouldRenderCrouton || isEmpty(croutonContent) || updateCartInProgress) {
        return null;
    }

    // When JioHotstar flow and cooking instructions are focused, hide crouton
    const hideForCookingInstructions = isJioHotstarFlow() && isCookingInstructionsFocused;

    return (
        <GenericCrouton
            {...croutonContent}
            visuallyHidden={hideForCookingInstructions}
            onCloseCrouton={onCloseCrouton}
        />
    );
};

export default memo(GenericCroutonWrapper);
